export const getModuleMessages = async (locale: ApplicationLocale) => import(`@/modules/appMarketplace/locales/${locale}.json`);

export default getModuleMessages;
